import React from 'react'
import {Col, Row, Statistic} from "antd";

const Appointments = ({data}) => {

    const {na, pa, wa} = data

    return (
        <React.Fragment>
            <Row>
                <Col span={8}>
                    <Statistic title={'Olumlu Randevu'} value={pa}/>
                </Col>
                <Col span={8}>
                    <Statistic title={'Olumsuz Randevu'} value={na}/>
                </Col>
                <Col span={8}>
                    <Statistic title={'Bekleyen Randevu'} value={wa}/>
                </Col>
            </Row>
        </React.Fragment>
    )
}
export default Appointments